import React from 'react';
import { ThemeProvider as ScThemeProvider } from 'styled-components';
import { createTheme, MuiThemeProvider } from '@material-ui/core/styles';
import { ThemeOptions } from '@material-ui/core/styles/createTheme';
import { GlobalStyle } from '../../utils/GlobalStyle/GlobalStyle';
import { theme as tinkDefaultTheme, TinkTheme } from './theme';
import { overrideMuiTheme } from './muiTheme';

type ThemeProviderProps = {
  theme?: TinkTheme;
  materialUiThemeOverrides?: ThemeOptions;
};

export const ThemeProvider: React.FC<ThemeProviderProps> = ({
  children,
  materialUiThemeOverrides,
  theme = tinkDefaultTheme,
}) => {
  const overrides = materialUiThemeOverrides || overrideMuiTheme(theme);

  return (
    <>
      <GlobalStyle theme={theme} />
      <ScThemeProvider theme={theme}>
        <MuiThemeProvider theme={createTheme(overrides)}>{children}</MuiThemeProvider>
      </ScThemeProvider>
    </>
  );
};
